'use client'

import { Badge, Cell, Image, Rating, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { EMPTY_USER_IMAGE_NAME, useAsset } from '@marketplace-web/shared/assets'
import { UserTitle } from '@marketplace-web/common-components/user-title-ui'

import { MEMBER_PROFILE_URL } from '../../constants/routes'

type Props = {
  login: string
  id: number
  averageRating: number
  ratingCount: number
  isBusiness: boolean
  photoUrl?: string | null
  businessAccountName?: string
  showChevron?: boolean
  testId?: string
}

const MAX_RATING = 5

const UserCell = ({
  login,
  photoUrl,
  id,
  averageRating,
  ratingCount,
  isBusiness,
  businessAccountName,
  showChevron = false,
  testId,
}: Props) => {
  const translate = useTranslate()
  const noPhotoAsset = useAsset('assets/no-photo')

  return (
    <Cell
      prefix={
        <Image
          role="img"
          src={photoUrl || noPhotoAsset(EMPTY_USER_IMAGE_NAME)}
          styling="circle"
          size="large"
        />
      }
      title={
        <UserTitle
          badgeTitle={translate('business.title')}
          businessAccountName={businessAccountName}
          login={login}
          isBusiness={isBusiness}
          isBody
          isBottomLoginHidden
          isBadgeHidden
          truncate
        />
      }
      url={MEMBER_PROFILE_URL(id)}
      type="navigating"
      chevron={showChevron}
      testId={testId}
    >
      <Rating
        aria={{
          'aria-label': averageRating
            ? translate('user.a11y.rating', { rating: averageRating, max_rating: MAX_RATING })
            : '',
        }}
        value={averageRating}
        text={ratingCount}
        size="small"
        emptyStateText={translate('user.feedback.no_reviews')}
        testId={testId ? `${testId}-rating` : undefined}
      />
      {isBusiness && (
        <>
          <Spacer size="small" />
          <Badge
            content={translate('business.title')}
            testId={testId ? `${testId}-business-badge` : undefined}
          />
        </>
      )}
    </Cell>
  )
}

export default UserCell
